import { useApi } from "#hooks/useApi"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { colaboradoresGet } from "modules/colaborador/services/api"
import { useMemo } from "react"
import { FormTableItem } from "./FormTableItem"

export default function FormTable({ listMovimientos }) {
	const params = useMemo(() => {
		const baseParams = {
			id: listMovimientos.map((mov) => mov.colaborador),
			promotion: true,
		}
		return baseParams
	}, [listMovimientos])

	const { data: colaboradoresData, loading } = useApi(colaboradoresGet, {
		params,
		autoFetch: listMovimientos.length,
	})
	const colaboradoresList = useMemo(() => {
		let data = colaboradoresData?.data || []
		data = data.map((colaborador) => {
			const movimiento = listMovimientos.find((mov) => mov.colaborador === colaborador.id)
			if (movimiento) {
				return {
					...colaborador,
					nombre: movimiento.perfilPuestoNewName,
				}
			}
			return colaborador
		})

		return data
	}, [colaboradoresData?.data, listMovimientos])
	let tableData = [
		{ label: "", id: "foto" },
		{ label: "No. Empleado", id: "no_empleado" },
		{ label: "Nombre", id: "full_name" },
		{ label: "Departamento", id: "departamento_name" },
		{ label: "Puesto", id: "perfil_puesto_name" },
		{ label: "Nuevo Puesto", id: "nombre" },
	]

	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
					<TableRow>
						{tableData.map((campo) => (
							<TableCell key={campo.id}>{campo.label}</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{colaboradoresList.map((colaborador) => {
						return (
							<FormTableItem
								key={colaborador?.id}
								colaborador={colaborador}
								tableData={tableData}
							/>
						)
					})}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
